import React, { useState } from 'react';
import {
  Row,
  Col,
  FormControl,
  InputGroup,
  FormGroup,
  ControlLabel,
} from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { ButtonBar, Button } from '../../../../common/components';
import { FullRow } from '../../../layout/components';
import { RadioSelectNotRedux } from '../../../../common/components/RadioSelect/RadioSelect';
import './BmiQuestion.scss';
import { MedicalQuestionContainer } from '../MedicalQuestionContainer/MedicalQuestionContainer';

const BMIInput = ({ value, addon, type, handleChangeTest }) => {
  const onChange = (e) => {
    handleChangeTest(type, e.target.value);
  };
  return (
    <>
      <InputGroup className={'bmi-input'}>
        <FormControl type="number" value={value} onChange={onChange} />
        <InputGroup.Addon>{addon}</InputGroup.Addon>
      </InputGroup>
    </>
  );
};
export const BmiQuestion = ({
  conditionNumber,
  questionNumber,
  question,
  info,
  warning,
  isEditingAnswer,
  onSetAnswer,
}) => {
  const { isSubmitting } = useSelector((state) => state.screening);

  const { height1, height2, weight1, weight2 } = question;
  const height = {
    height1,
    height2,
  };
  const weight = {
    weight1,
    weight2,
  };

  const isMetricValue = question?.is_metric_system;
  const setAnswer = (values) => {
    onSetAnswer(conditionNumber, questionNumber, values, isEditingAnswer);
  };

  const cancelEditing = () => {
    onSetAnswer(conditionNumber, questionNumber, question);
  };

  return (
    <MedicalQuestionContainer
      isActive
      button={
        isEditingAnswer &&
        !warning && (
          <Button
            bsStyle="primary"
            size={'xs'}
            label={warning ? 'Update' : 'Cancel'}
            handleClick={cancelEditing}
          />
        )
      }
    >
      <BmiComponent
        info={info}
        onSetAnswer={setAnswer}
        isSubmitting={isSubmitting}
        isMetric={isMetricValue}
        heightValue={height}
        weightValue={weight}
      />
    </MedicalQuestionContainer>
  );
};

const BmiComponent = ({
  info,
  onSetAnswer,
  isSubmitting,
  isMetric,
  heightValue,
  weightValue,
}) => {
  const [height, setHeight] = useState(heightValue);
  const [weight, setWeight] = useState(weightValue);
  const [isMetricSystem, setMetricSystem] = useState(!!isMetric);

  const handleMetricChange = (value) => {
    const isMetric = value === 'metric';
    setMetricSystem(isMetric);
    setHeight(
      isMetric
        ? {
            height1: 0,
          }
        : {
            height1: 0,
            height2: 0,
          },
    );
    setWeight(
      isMetric
        ? {
            weight1: 0,
          }
        : {
            weight1: 0,
            weight2: 0,
          },
    );
  };

  const handleHeightChange = (type, event) => {
    if (isMetricSystem) {
      setHeight({
        height1: event,
      });
    } else {
      setHeight({
        ...height,
        [type]: event,
      });
    }
  };

  const handleWeightChange = (type, event) => {
    if (isMetricSystem) {
      setWeight({
        weight1: event,
      });
    } else {
      setWeight({
        ...weight,
        [type]: event,
      });
    }
  };

  const setAnswer = () => {
    onSetAnswer({ is_metric_system: isMetricSystem, ...height, ...weight });
  };

  return (
    <div>
      <FullRow>
        Please enter your height and weight
        {info && (
          <p className="text-info text-justify">
            {info}
            <br />
          </p>
        )}
      </FullRow>
      <FullRow>
        <RadioSelectNotRedux
          inline={'inline'}
          options={[
            { value: 'metric', label: 'Metric Measure?' },
            { value: 'imperial', label: 'Imperial measure?' },
          ]}
          value={isMetricSystem ? 'metric' : 'imperial'}
          onChange={handleMetricChange}
        />
      </FullRow>

      <FormGroup>
        <Col sm={2}>
          <ControlLabel>Height</ControlLabel>
        </Col>
        <Col sm={isMetricSystem ? 6 : 4}>
          <BMIInput
            value={height.height1}
            type={'height1'}
            addon={isMetricSystem ? 'cm' : 'ft'}
            handleChangeTest={handleHeightChange}
          />
        </Col>
        {!isMetricSystem && (
          <Col sm={isMetricSystem ? 6 : 4}>
            <BMIInput
              value={height.height2}
              type={'height2'}
              addon={'in'}
              handleChangeTest={handleHeightChange}
            />
          </Col>
        )}
      </FormGroup>
      <Row>
        <Col sm={2}>
          <ControlLabel>Weight</ControlLabel>
        </Col>
        <Col sm={isMetricSystem ? 6 : 4}>
          <BMIInput
            value={weight.weight1}
            type={'weight1'}
            addon={isMetricSystem ? 'kg' : 'st'}
            handleChangeTest={handleWeightChange}
          />
        </Col>
        {!isMetricSystem && (
          <Col sm={isMetricSystem ? 6 : 4}>
            <BMIInput
              value={weight.weight2}
              type={'weight2'}
              addon={'lb'}
              handleChangeTest={handleWeightChange}
            />
          </Col>
        )}
      </Row>

      <FullRow>
        <ButtonBar>
          <Button
            bsStyle="primary"
            isLoading={isSubmitting}
            label="Set Height and Weight"
            handleClick={setAnswer}
          />
        </ButtonBar>
      </FullRow>
    </div>
  );
};
